<template>
  <div class="addres-page-stats">
    <div class="info-board">
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[AmazonAddress] }} Address</span>
          <span class="sub-title">{{ AmazonAddress }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[FedexAddress] }} Address</span>
          <span class="sub-title">{{ FedexAddress }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[UPSAddress] }} Address</span>
          <span class="sub-title">{{ UPSAddress }}</span>
        </div>
      </div>
      <div class="stats-info-card blue-business-bg">
        <div class="info-card-left">
          <span class="title">{{ counts[OtherAddress] }} Address</span>
          <span class="sub-title">{{ OtherAddress }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// model
import {
  AmazonAddress,
  FedexAddress,
  UPSAddress,
  OtherAddress
} from '@/core/models/constant'
import { queryAddress } from '@/api/address'
export default {
  name: 'AddressStats',
  data() {
    return {
      AmazonAddress,
      FedexAddress,
      UPSAddress,
      OtherAddress,
      counts: {
        [AmazonAddress]: 999,
        [FedexAddress]: 999,
        [UPSAddress]: 999,
        [OtherAddress]: 999
      }
    }
  },
  mounted() {
    this.countOrders(AmazonAddress)
    this.countOrders(FedexAddress)
    this.countOrders(UPSAddress)
    this.countOrders(OtherAddress)
  },
  methods: {
    countOrders(type) {
      queryAddress({
        type,
        size: 0
      }).then(res => {
        this.counts[type] = res.total
      })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.info-board {
  gap: 10px;

  .stats-info-card {
    pointer-events: none;
    min-width: 160px !important;

    .info-card-left {
      .title {
        font-size: 30px;
        font-family: 'oswald bold', sans-serif;
      }

      .sub-title {
        margin-top: 5px;
        font-size: 24px;
        font-family: 'oswald light', sans-serif;
      }
    }
  }

  @extend .global-margin;
  @extend .f-r-vc;
}
</style>
